/**
 * Screen a push opens, from its `url` (the API's `notifications.url`, e.g.
 * `/bustickets/12`) and the role of the session. Drivers always land on their
 * notifications; passengers on the screen of the url's first segment, or on the
 * notifications inbox when there is no better one.
 */
export function pushRoute(url: string | undefined, role: string | undefined): string {
  if (role === 'driver') {
    return 'driver/notification';
  }

  const path = (url ?? '').replace(/^https?:\/\/[^/]+/, '');
  const segment = path.split('/').filter(Boolean)[0];

  switch (segment) {
    case 'bustickets':
    case 'busticket_packages':
      return 'bustickets';
    case 'tickets':
      return 'support';
    case 'memberships':
      return 'memberships/home';
    default:
      return 'notification';
  }
}
